import { prefillShopUrl } from './prefillSourceUrl';

interface UseBrandWebsiteButtonProps {
  /** The source's current URL; the button only shows while it is empty. */
  value: string;
  brandWebsite?: string;
  onUse: (url: string) => void;
}

/**
 * "Use brand website (shop.com)" under an empty Square Online / WooCommerce
 * URL field. Renders nothing once the field has a value or when the brand has
 * no website.
 */
export function UseBrandWebsiteButton({ value, brandWebsite, onUse }: UseBrandWebsiteButtonProps) {
  const url = prefillShopUrl(brandWebsite);
  if (value.trim() || !url) return null;
  let host = url;
  try {
    host = new URL(url).hostname.replace(/^www\./, '');
  } catch {
    // keep the full string
  }
  return (
    <button
      type="button"
      onClick={() => onUse(url)}
      className="text-xs text-brand-600 hover:text-brand-700 underline"
    >
      Use brand website ({host})
    </button>
  );
}
